import { render, staticRenderFns } from "./PonitExchange.vue?vue&type=template&id=672d6cea&scoped=true&"
import script from "./PonitExchange.vue?vue&type=script&lang=js&"
export * from "./PonitExchange.vue?vue&type=script&lang=js&"
import style0 from "./PonitExchange.vue?vue&type=style&index=0&id=672d6cea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672d6cea",
  null
  
)

export default component.exports